import {observer} from "mobx-react"
import React, {Component, Fragment} from "react"
import {Button, Icon, Input, Segment} from "semantic-ui-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore"
import _ from "lodash"
import {Link} from "react-router-dom"
import Price from "components/Price/Price"
import ButtonLove from "components/Button/ButtonLove"
import { Label, Modal } from "semantic-ui-react"
import OrderModel   from "shop/OrderModel";
import ImageWithFallback from "components/ImageWithFallback"
import ProductImages from "components/Product/ProductImages"
import ProductFullscreen from "components/Product/ProductFullscreen"
import Responsive                                                from "react-responsive"
import Collapsible                                                                    from 'react-collapsible';
import htmr                                                                           from "htmr";

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0

@observer
export default class ProductListItem extends Component {

	state = {
		session: shop.session || {}, locations: [], showAddressBook: false, noMoreOrders: false, orderOpen: [], maxOrders: 5, maxOpenOrders: 5, bausteinValue: "", bausteinSeason: "", fullscreenElement: null,
	  }

	  loadSession = ( session ) => {
		this.setState( { noMoreOrders: false } )
	  }
	  componentDidMount() {
		orders = []
		ordersWithOpenPositions = []
		openPositions = []
		current = 0
		shop.events.authentified.add( this.loadSession )
		this.handleGetExtras()
		// this.loadSession()
	  }
	  handleGetExtras = () => {
        console.log("EXTRAS", shop.cart.data)
        if(shop.cart && shop.cart.data && shop.cart.data.extras && shop.cart.data.extras.bausteinValue){
            this.setState({bausteinValue: shop.cart.data.extras.bausteinValue})
			this.setState({bausteinSeason: shop.cart.data.extras.bausteinSeason})
        }
      }
	 showFullscreen = ( element ) => {
		console.log("PRODUCTIMAGE showFullscreen", element)
		this.setState( {
			fullscreenElement: element
		} )
	}
	setPrimaryImage = ( primaryImage ) => {
		this.setState( {primaryImage} )
	}
	
	render() {
		let {product, index, categoryId = "", to = "/", search = "", history, place} = this.props
		let { bausteinValue, bausteinSeason, fullscreenElement, primaryImage } = this.state
		console.log("this.props",product, bausteinValue, bausteinSeason, history)
		if ( !product ) return <div>NO PRODUCT</div>
		let configByCategory = cmsStore.config.orthoFieldConfigByCategory[String( product.category && product.category.map_id )]

		let isDefaultConfig = false
		if ( !configByCategory ) {
			isDefaultConfig = true
			configByCategory = cmsStore.config.orthoFieldConfigByCategory["DEFAULT"]
		}
		const columnChunks = _.chunk( configByCategory.columns, 1 )
		const inCart = shop.cart.productsById.get( product.map_id ) || product

		if(product.map_id == bausteinValue){
			console.log("found bausteinValue: ", product.map_id, bausteinValue, bausteinSeason, product)
		}
		
		let productImage = false
		let img_srcs = product.img_srcs
		if ( product.img_src ) {
			productImage = product.img_src_large
		}

		if ( primaryImage ) productImage = primaryImage

		const formatPrice = (price) => {
			if (!price) return "0,00"
			return (price).toFixed(2).toString().replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
		}

		return ( 
			<React.Fragment>
				<ProductFullscreen
					change={this.showFullscreen}
					images={img_srcs}
					image={fullscreenElement} />

				<Responsive minWidth={992}>
					<Segment
					attached={"bottom"}
					className={`product db  w-100  relative ${product.map_id == bausteinValue+bausteinSeason ? "ProductListItem-highlight" : "ProductListItem"}`}>
					<table>
						<colgroup>
							<col width="10%" />
							<col width="20%" />
							<col width="30%" />
							<col width="15%" />
							<col width="15%" />
							<col width="10%" />
						</colgroup>
						<tbody>
							<th>
								<td style={{border: "none"}}>&nbsp;</td>
							</th>
							<th>
								<td style={{border: "none"}}>Baustein</td>
							</th>
							<th>
								<td style={{border: "none"}}>Beschreibung</td>
							</th>
							<th>
								<td style={{border: "none"}}>UVP</td>
							</th>
							<th>
								<td style={{border: "none"}}>FAP</td>
							</th>
							<th>
								<td style={{border: "none"}}>&nbsp;</td>
							</th>
							<tr>
								<td style={{border: "none"}}>{<ProductImages
															key={product.map_id}
															product={product}
															images={img_srcs}
															image={productImage}
															onClick={this.showFullscreen}
															onClickSecondary={this.setPrimaryImage} />} </td>
								<td style={{border: "none"}}>{<div className={"f5  w-100"} key={product.map_id + "desc"}>{product.desc.short_des}</div>}</td>
								<td style={{border: "none"}}>{<div className={"f5  w-100"} key={product.map_id + "desc"}>{product.desc.des}</div>}</td>
								<td style={{border: "none"}}>{<div className={"f5  w-100"} key={product.map_id + "desc"}>{product.extras && product.extras.uvp && product.extras.uvp.value.value}</div>}</td>
								<td style={{border: "none"}}>{<div className={"f5  w-100"} key={product.map_id + "desc"}>€ {formatPrice(product.price)}</div>}</td>
								{place != "return" && <td className="pr3" style={{border: "none"}}><ProductQuantitySimple primaryProduct={product.map_id == bausteinValue+bausteinSeason ? true : false}  place={place} product={product} inCart={inCart} history={history} /></td>}
							</tr>
						</tbody>
					</table>
					<div className="bausteinInhalt_div">
						<Collapsible tabIndex={0} open={false} trigger={translate( "Bausteininhalt" )}>
						<div className="f6 gray">Hier finden Sie eine Auflistung der Displays, die in diesem Baustein enthalten sind.</div>
						<table className="bausteinInhalt-table">
							<colgroup>
								<col width="30%" />
								<col width="50%" />
								<col width="20%" />
							</colgroup>
							<tbody>
								<tr>
									<th style={{border: "none"}}><strong>{translate("Display")}</strong></th>
									<th style={{border: "none"}}><strong>{translate("Bezeichnung")}</strong></th>
									<th style={{border: "none"}}><strong>{translate("Menge")}</strong></th>
								</tr>
							{product.extras && product.extras.inhalt && product.extras.inhalt.value && JSON.parse(product.extras.inhalt.value.value).map((item, idx) => (
							<tr key={idx} className="">
								<td>{item.display}</td>
								<td className="tl">{item.bezeichnung}</td>
								<td className="">{item.menge} {translate("Display")}</td>
							</tr>
						))}
								</tbody>
							</table>

							</Collapsible>
						</div>
					</Segment>
					</Responsive>

				<Responsive maxWidth={991}>
					<div className={`pa3 mb3 ${product.map_id == bausteinValue+bausteinSeason ? "bausteinSegment-highlight" : "bausteinSegment"}`}>
					<table className={"w-100"} style={{border: "none"}}>
						<colgroup>
							<col width="30%" />
							<col width="70%" />
						</colgroup>
						<tbody>
							<tr>
								<td style={{border: "none"}}>
									&nbsp;
								</td>
								<td style={{border: "none", maxWidth: "70px", maxHeight: "70px", minWidth: "70px", minHeight: "70px"}}>
									{<ProductImages
															key={product.map_id}
															product={product}
															images={img_srcs}
															image={productImage}
															onClick={this.showFullscreen}
															onClickSecondary={this.setPrimaryImage} />}
								</td>
							</tr>
							<tr>
								<td className="ProductRowDefReturnMobileLeftNonLast">Baustein:</td>
								<td className="ProductRowDefReturnMobileRightNonLast tr">
									{product.desc.short_des}
								</td>
							</tr>
							<tr>
								<td className="ProductRowDefReturnMobileLeftNonLast">Beschreibung:</td>
								<td className="ProductRowDefReturnMobileRightNonLast tr">
									{product.desc.des}
								</td>
							</tr>
							<tr>
								<td className="ProductRowDefReturnMobileLeftNonLast">UVP:</td>
								<td className="ProductRowDefReturnMobileRightNonLast tr">
									{product.extras && product.extras.uvp && product.extras.uvp.value.value}
								</td>
							</tr>
							<tr>
								<td className="ProductRowDefReturnMobileLeftNonLast">Preis:</td>
								<td className="ProductRowDefReturnMobileRightNonLast tr">
									€ {formatPrice(product.price)}
								</td>
							</tr>
							<tr>
								<td colSpan={2} className="pt4">
									{place != "return" && <ProductQuantitySimple primaryProduct={product.map_id == bausteinValue+bausteinSeason ? true : false} place={place} product={product} inCart={inCart} history={history} />}
								</td>
							</tr>
						</tbody>
					</table>
					<div className="bausteinInhalt_div_mobile">
						<Collapsible tabIndex={0} open={false} trigger={translate( "Bausteininhalt" )}>
						<div className="f6 gray">Hier finden Sie eine Auflistung der Displays, die in diesem Baustein enthalten sind.</div>

						{product.extras && product.extras.inhalt && product.extras.inhalt.value && JSON.parse(product.extras.inhalt.value.value).map((item, idx) => (
							<Fragment key={idx}>
								<div className=" bb b--black-30 pt2 pb2">
									<div className="bausteinInhalt_div_mobile"><strong>{translate("Display:")}&nbsp;</strong> {item.display}</div>
									<div className="bausteinInhalt_div_mobile"><strong>{translate("Bezeichnung:")}&nbsp;</strong><p className="tr"> {item.bezeichnung}</p></div>
									<div className="bausteinInhalt_div_mobile"><strong>{translate("Menge:")}&nbsp;</strong> {item.menge} {translate("Display")}</div>
								</div>
							</Fragment>))}
						</Collapsible>
					</div>
					</div>
				</Responsive>
			</React.Fragment>
		)
	}
}

function ProductQuantitySimple( {primaryProduct, place, product, inCart = {}, history} ) {
  const [count, setCount] = React.useState(inCart && inCart.count || 0)
  const [isDirty, setDirty] = React.useState(false)
  const [isLoading, setLoading] = React.useState(false)
  const [modalOpen, setModalOpen] = React.useState(false)

  const same = count === inCart.count

  React.useEffect(() => {
    if (isDirty) return
    setCount(inCart.count)
  }, [product, inCart])
	return <div className={"ProductQuantitySimple flex flex-row items-center"}>
				<Modal
					closeIcon={<Icon name="close" />}
					open={modalOpen}
					onClose={() => setModalOpen(false)}
					size="tiny"
				>
					<Modal.Header>{translate( "Sind Sie sicher, dass Sie einen von unserem Vorschlag abweichenden Baustein bestellen möchten?" )}</Modal.Header>
					<Modal.Content>
					<div className="f4 fw5 pb3 pt2 flex flex-row justify-between">
						                  <Button
                    style={{ borderRadius: "25px", height: "45px" }}
                    primary
                    onClick={async () => {

                      // Falls User im Modal bestätigt → Produkt trotzdem hinzufügen
                      let n = 1
                      setLoading(true)

                      product.count = n
					await shop.cart.setExtra("lieferzeitraum", product.extras && product.extras.lieferzeitraum && product.extras.lieferzeitraum.value ? product.extras.lieferzeitraum.value.value : "")
					await shop.cart.postCart("cart" , {"positions": []})
					await shop.cart.add( product )
					await shop.cart.setExtra("bausteinValue", product.map_id.substring(0, 1))
					console.log("set bausteinValue in cart extras", product.map_id.substring(0, 1))
                    shop.toast( translate( "Baustein hinzugefügt" ) )
					setDirty( false )
					await delay( 300 )
					setModalOpen(false)
					setLoading( false )
					history.push("/return/contactPerson")

                      
                    }}
                  >
                    Ja, Baustein hinzufügen
                  </Button>
				  							<Button style={{borderRadius: "25px", height: "45px"}} onClick={() => {
								setModalOpen(false)
							}}>Abbrechen</Button>
					</div>
					
					</Modal.Content>
				</Modal>
		<Button
			primary
			loading={isLoading}
			style={{width: place == "returnEmpfehlung" ? "150px" : "150px", borderRadius: "25px"	}}
			onClick={async () => {
				let n = 1

				setLoading( true )
				if (!primaryProduct) {
					setLoading(false)
					setModalOpen(true)
					return
				}
				else{
				product.count = n
				await shop.cart.setExtra("lieferzeitraum", product.extras && product.extras.lieferzeitraum && product.extras.lieferzeitraum.value ? product.extras.lieferzeitraum.value.value : "")
				await shop.cart.postCart("cart" , {"positions": []})
				await shop.cart.add( product )
				shop.toast( translate( "Baustein hinzugefügt" ) )
				setDirty( false )
				await delay( 300 )
				setLoading( false )
				history.push("/return/contactPerson")
				}
			}} ><p>{ place == "returnEmpfehlung" ? htmr(translate("Empfehlung<br/> bestellen")) : htmr(translate("Weiter"))} </p></Button>
	</div>
}

function delay( ms ) {
	return new Promise( resolve => setTimeout( resolve, ms ) );
}


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/Product/ProductListItem.js